module.exports = __webpack_public_path__ + "img/DICH_VU_GIAI_TRI.5dfd43de.svg";